export var Assertions;
(function (Assertions) {
    function assertDefined(x, message) {
        if (x === null || x === undefined)
            throw message ? new Error(message) : new Error(`Undefined value`);
    }
    Assertions.assertDefined = assertDefined;
    function assertElementListDefined(x, message) {
        if (x === null || x === undefined)
            throw new Error(`Undefined list`);
        x.forEach((e, n) => {
            if (e === null || x === undefined)
                throw message ? new Error(`${message} in index ${n}`) : new Error(`Undefined value in index ${n}`);
        });
    }
    Assertions.assertElementListDefined = assertElementListDefined;
    function assertElementMatrixDefined(x, message) {
        if (x === null || x === undefined)
            throw new Error(`Undefined list`);
        x.flat().forEach((e, n) => {
            if (e === null || x === undefined)
                throw message ? new Error(`${message} in index ${n}`) : new Error(`Undefined value in index ${n}`);
        });
    }
    Assertions.assertElementMatrixDefined = assertElementMatrixDefined;
})(Assertions || (Assertions = {}));
//# sourceMappingURL=Assertions.js.map